/**
 * Backwards-compatible re-export.
 * All services import from '@/integrations/supabase/client'.
 * This re-exports the browser client from the new location.
 */
export { supabase, supabaseAny, uploadFile, getPublicUrl } from '@/lib/supabase/client';
